<nav
  *transloco="let t"
  id="mobile-bottom-nav"
  class="bg-white border-t border-ld-border flex justify-around px-5 pt-4 z-50 shadow-[0_-2px_10px_rgba(0,0,0,0.1)]"
  role="navigation"
  [attr.aria-label]="t('commonAriaMainNavigation')"
>
  @for (item of translatedNavItems(); track item.id) {
    <button
      [id]="'mobile-nav-' + item.id"
      type="button"
      class="flex flex-1 flex-col items-center gap-0.5 bg-transparent border-none p-0 cursor-pointer transition-colors duration-200"
      [class.text-ld-primary]="isActive(item)"
      [class.text-ld-neutral-400]="!isActive(item)"
      [attr.aria-current]="isActive(item) ? 'page' : null"
      [attr.aria-label]="item.label"
      (click)="onNavItemClick(item)"
    >
      <ld-svg-icon [id]="'mobile-nav-icon-' + item.id" [src]="getIconSrc(item)" aria-hidden="true" class="w-6 h-6" />
      <span [id]="'mobile-nav-label-' + item.id" class="font-dm text-[11px] font-semibold leading-3">
        {{ item.label }}
      </span>
    </button>
  }
</nav>
